export default "__VITE_PUBLIC_ASSET__34ac7d3b__"